module.exports = __webpack_public_path__ + "static/media/users.431218aa.svg";